import { useCallback } from 'react';
import useFetchRecentFolders, { useGetRecentFolderSettingKey } from './useFetchRecentFolders';
import useSaveUserSettings from 'framework-listing-lib/internal/userSettings/hooks/useSaveUserSettings';
import { UNFILED_ASSETS_ID } from 'framework-listing-lib/internal/Folders/constants/folders';

/**
 * Stores the top 10 used folders.
 */
export default function useUpdateRecentFolders() {
  const settingKey = useGetRecentFolderSettingKey();
  const saveUserSettings = useSaveUserSettings();
  const {
    recentFolders
  } = useFetchRecentFolders();
  return useCallback((folderId, action) => {
    let newRecentFolders = [];
    if (action && action === 'DELETE') {
      newRecentFolders = recentFolders.filter(folder => folder.id !== folderId);
    } else {
      const maybeExistingFolder = recentFolders.find(recentFolder => recentFolder.id === folderId);
      if (maybeExistingFolder) {
        newRecentFolders = [Object.assign({}, maybeExistingFolder, {
          timesUsed: maybeExistingFolder.timesUsed + 1
        }), ...recentFolders.filter(recentFolder => recentFolder.id !== maybeExistingFolder.id)];
      } else {
        newRecentFolders = [{
          id: folderId,
          timesUsed: 1
        }, ...recentFolders];
      }
    }
    const top10Folders = newRecentFolders.slice(0, 10);

    // Move "All assets" folder to the top
    const allAssetsFolder = top10Folders.find(folder => folder.id === UNFILED_ASSETS_ID);
    return saveUserSettings({
      key: settingKey,
      value: JSON.stringify(allAssetsFolder ? [allAssetsFolder, ...top10Folders.filter(folder => folder.id !== UNFILED_ASSETS_ID)].filter(Boolean) : top10Folders)
    }).then(() => {}).catch(() => {});
  }, [recentFolders, saveUserSettings, settingKey]);
}